import { useState } from 'react';
import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';  // ✅ replaces this.props.children
import HeaderView from './HeaderView';
import SideMenuView from './SideMenuView';

const { Sider, Content } = Layout;

const LayoutView = () => {
  const [collapsed, setCollapsed] = useState(false);

  const toggleCollapse = (value: boolean) => {
    setCollapsed(value);
  };

  return (
    <Layout style={{ minHeight: '100vh', height: 'auto' }}>
      {localStorage.getItem('access_token') ? (
        <>
          <HeaderView />
          {/* AP-5865: let the whole document scroll (same as Production) rather
              than clamping the shell to 100vh with Content as its own scroll
              box — that inner scroll made page titles slide up under the header
              edge. AP-5874's docked sidebar toggle is handled with
              position: sticky in _sidebar.scss instead of the clamp.
              height: 'auto' overrides App.css's `.ant-layout { height: 100vh }`,
              which otherwise caps the Sider at one screen while Content spills
              past it — the toggle then scrolls off with that short Sider and
              ends up floating beside the table. */}
          <Layout style={{ height: 'auto' }}>
            <Sider
              theme="light"
              trigger={null}
              collapsible
              collapsed={collapsed}
              onCollapse={toggleCollapse}
            >
              <SideMenuView siderCollapsed={collapsed} collapseToggle={toggleCollapse} />
            </Sider>
            <Content style={{ padding: 12, minHeight: 280 }}>
              <Outlet />  {/* ✅ renders child routes */}
            </Content>
          </Layout>
        </>
      ) : (
        <Content style={{ padding: 12, minHeight: 280 }}>
          <Outlet />      {/* ✅ renders login/forgot/reset when no token */}
        </Content>
      )}
    </Layout>
  );
};

export default LayoutView;